import {
  createSerializationOptionsForEnumValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

import { BrandAffinityLevel } from 'modules/domains/brandAffinity/BrandAffinityLevel';

export const useBrandAffinityInsightsSearchParams = () => {
  const [selectedTab, setSelectedTab] = useSearchParamState({
    searchParamKey: 'tab',
    stateValueWhenSearchParamIsUnset: BrandAffinityLevel.LOYAL,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: BrandAffinityLevel,
      stateValueWhenSearchParamIsInvalid: BrandAffinityLevel.LOYAL,
    }),
  });

  return {
    selectedTab,
    setSelectedTab,
  };
};
